import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { css } from '@emotion/react';
import { reds } from '@/styles/colors';

// Shared row-level kebab menu for the CorporateUsers table (Shippers, Flex Centers,
// Fulfillment Partners, Motor Carriers). Owns the anchor state and stopPropagation so
// a click inside the menu never toggles the row's expand/collapse or triggers a row click.
// `items`: [{ key, label, onClick, disabled, danger }]
const RowActionsMenu = ({ items = [] }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const visibleItems = items.filter(Boolean);
    if (visibleItems.length === 0) return null;

    const open = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const close = (e) => {
        e?.stopPropagation?.();
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton size="small" aria-label="Actions" onClick={open}>
                <MoreVert />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={close}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                getContentAnchorEl={null}
            >
                {visibleItems.map(({ key, label, onClick, disabled, danger }) => (
                    <MenuItem
                        key={key}
                        disabled={disabled}
                        onClick={(e) => {
                            e.stopPropagation();
                            close();
                            onClick?.();
                        }}
                        css={
                            danger &&
                            css`
                                color: ${reds.primary};
                            `
                        }
                    >
                        {label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default RowActionsMenu;
